import { Injectable } from "@angular/core"
import { AngularFirestoreCollection, AngularFirestoreDocument } from "@angular/fire/firestore"

import { Company, CompanyUser } from "@tr/models"
import { ApiPaths, ApiService } from "./api.service"
import { FirebaseCollectionBase } from "./firebase-resource-base"
import { FirebaseService } from "./firebase.service"

@Injectable({
  providedIn: "root",
})
export class CompaniesService extends FirebaseCollectionBase<Company> {
  public getId = (item: Company) => item._id

  constructor(fb: FirebaseService, private api: ApiService) {
    super(fb)
  }

  public async companyExists(company: string): Promise<boolean> {
    try {
      await this.api.head(`${ApiPaths.companies}/${company}`)
      return true
    } catch (err) {
      return false
    }
  }

  public getCollection(): AngularFirestoreCollection {
    return this.firebaseService
      .collection("companies")
  }

  public getProjectCollection(company: string): AngularFirestoreCollection {
    return this.getCollection()
      .doc(company)
      .collection("projects")
  }

  public getCompanyUsersCollection(company: string): AngularFirestoreCollection {
    return this.getCollection()
      .doc(company)
      .collection("users")
  }

  public getCompanyUserDoc(company: string, uid: string): AngularFirestoreDocument {
    return this.getCompanyUsersCollection(company).doc(uid)
  }

  public async getCompanyUser(company: string, uid: string): Promise<CompanyUser> {
    const userSnapshot = await this.getCompanyUserDoc(company, uid).ref.get()
    return {
      ...userSnapshot.data() as CompanyUser,
      _id: userSnapshot.id,
    }
  }

  public getCreditsDocument(company: string): AngularFirestoreDocument {
    return this.getCollection()
      .doc(company)
      .collection("credits")
      .doc("credits")
  }

  public async getData(): Promise<Company[]> {
    const collectionSnapshot = await this.getCollection().ref.get()

    this.data = collectionSnapshot.empty
      ? []
      : collectionSnapshot.docs.map<Company>(companySnapshot => {
        const company = companySnapshot.data() as Company
        company._id = companySnapshot.id
        this.dataMap[companySnapshot.id] = company
        return company
      })

    return this.data
  }

  public async update(
    companyId: string,
    companyToUpdate: any,
  ): Promise<void> {
    return this.getCollection()
      .doc(companyId)
      .update(companyToUpdate)
  }
}
